module.exports = __webpack_public_path__ + "static/media/client-salesforce.fa889365.png";